(ns superadmin.users.queries
  (:require [cljs-bean.core :refer [->clj ->js]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn users-query [params]
  #js {:queryKey #js ["sa-users" (->js params)]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :superadmin-api/users {} params)))
       :staleTime (* 5 60 1000)})

(defn create-user-mutation []
  #js {:mutationKey #js ["sa-create-user"]
       :mutationFn (fn [user-data]
                     (rf/dispatch [:loader/open])
                     (qhttp/post (qhttp/render :superadmin-api/users {})
                                 {:body user-data}))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["sa-users"]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "User"
                                      :type :success
                                      :message "Successfully created user"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "User"
                                 :type :error
                                 :message "Failed to create user"
                                 :response (->clj response)}]))})

(defn user-query [{:keys [user-id]}]
  #js {:queryKey #js ["user" user-id]
       :enabled (some? user-id)
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/user {:user-id user-id})))
       :staleTime (* 5 60 1000)})

(defn user-grants-query [{:keys [user-id]}]
  #js {:queryKey #js ["sa-user-grants" user-id]
       :enabled (some? user-id)
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :superadmin-api/grants {} {:useraccount-id user-id})))
       :staleTime (* 5 60 1000)})

(defn delete-user-grant-mutation [{:keys [user-id]}]
  #js {:mutationKey #js ["delete-user-grant" user-id]
       :mutationFn (fn [grant-id]
                     (rf/dispatch [:loader/open])
                     (qhttp/delete (qhttp/render :superadmin-api/delete-grants {:grant-id grant-id})))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["sa-user-grants" user-id]})
                       (invalidate-queries {:queryKey ["sa-users"]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Grant"
                                      :type :success
                                      :message "Successfully deleted grant"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Grant"
                                 :type :error
                                 :message "Failed to delete grant"
                                 :response (->clj response)}]))})

(defn create-user-grant-mutation [{:keys [user-id]}]
  #js {:mutationKey #js ["create-user-grant" user-id]
       :mutationFn (fn [grant-data]
                     (rf/dispatch [:loader/open])
                     (qhttp/post (qhttp/render :superadmin-api/grants {:user-id user-id})
                                 {:body (merge grant-data {:useraccount-id user-id})}))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["sa-user-grants" user-id]})
                       (invalidate-queries {:queryKey ["sa-users"]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Grant"
                                      :type :success
                                      :message "Successfully created grant"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Grant"
                                 :type :error
                                 :message "Failed to create grant"
                                 :response (->clj response)}]))})

(defn wpp-os-search-users [search]
  (qhttp/get (qhttp/render :api/wpp-os-users {}
                           {:search search :limit 10})))

(defn transform-advertisers [^js data]
  (->> (->clj data)
       (mapv (fn [advertiser]
               (assoc advertiser :campaign-count (count (:campaignIds advertiser)))))))

(defn agency-advertisers-query [agency-id]
  #js {:queryKey #js ["agency-advertisers" agency-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :superadmin-api/agency-advertisers {:agency-id agency-id})))
       :select transform-advertisers
       :enabled (pos-int? agency-id)
       :staleTime (* 60 1000)})
